import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmPasswordValidator } from "./confirm-password.validator";
import { QueryModel } from "app/models/queryModel";
import { CookieService } from "ngx-cookie-service";
import { UserService } from "app/services/user.service";
import { ResetPasswordObject } from "../../models/queryModel";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Router } from "@angular/router";
@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"],
})
export class ResetPasswordComponent implements OnInit {
  constructor(
    private _fb: FormBuilder,
    private userService: UserService,
    private cookieService: CookieService,
    private router:Router
  ) {}
  registerForm: FormGroup;
  submitted: boolean = false;
  resetPasswordObject: ResetPasswordObject = new ResetPasswordObject();
  ngOnInit(): void {
    this.registerForm = this._fb.group(
      {
        password: ["", Validators.required],
        confirmPassword: ["", Validators.required],
      },
      {
        validator: ConfirmPasswordValidator("password", "confirmPassword"),
      }
    );
  }

  getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

  updatePasswordForm() {
    this.resetPasswordObject.reset_password.user_email = this.getParameterByName("useremail");
    this.resetPasswordObject.reset_password.token = this.getParameterByName("token");



    this.resetPasswordObject.reset_password.user_password =
      this.registerForm.value.confirmPassword;

      console.log(window.location.search);


    this.userService.GetMethod(this.resetPasswordObject).subscribe((res) => {
      console.log("Response of the Reset password call", res);
      if (res.body.message !== "Password has been successfully updated!") {
        let template = `
        <div style='text-align:center'>
        <div style='margin-bottom: 10px; margin-top: 5px'>
            <b>${res.body.message}</b>
        </div>
        <div style="text-align:left; margin-left: 30px">
        `;
        var base64regex =
          /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
        for (let i = 0; i < res.body.criteria.length; i++) {
          if (base64regex.test(res.body.criteria[i]) == true) {
            // console.log("Yes it is base64");
            template =
              template + `<b>${i + 1}. </b>${atob(res.body.criteria[i])} <br>`;
            i = i + 1;
          }
          template =
            template + `<b>${i + 1}. </b> ${res.body.criteria[i]} <br>`;
        }
        template = template + `</div></div>`;

        // console.log("Template after completion:", template);

        Swal.fire({
          html: `${template}`,
        });

        this.cookieService.delete("resetEmail");
        this.cookieService.delete("resetToken");
        this.registerForm.reset();
      } else {
        this.router.navigate(["/login"]);

        Swal.fire({
          icon: "success",
          title: "Password has been updated",
        });
      }
    });
  }

  closeModal() {
    this.registerForm.reset();
    this.router.navigate(["/login"]);
    console.log("TEST");
  }

  onSubmit() {
    this.submitted = true;
  }
}
